















































































































































































































































































































































import AppApiMixin from "@/components/mixins/AppApi.vue";
import {Component, Mixins, Watch} from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import SimpleButton from "@/components/SimpleButton.vue";
import DropdownWithDatePickerWithoutRange from "@/components/hoc/DropdownWithDatePickerWithoutRange.vue";
import {mapGetters, mapState} from "vuex";
import {AppealThemes, AppealThemeTypes} from "@/models/appeals";
import {AccountingPoint} from "@/models/accounting-point";
import {appealsAcceptedExtensions} from "@/assets/scripts/utils";
import moment from 'moment';
// import VueTimepicker from 'vue2-timepicker'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';

@Component({
  components: {
    Page,
    XNotice,
    SimpleButton,
    DropdownWithDatePickerWithoutRange,
    VueTimepicker,
  },
  computed: {
    ...mapGetters("contract", {
      contractId: "id",
      contractNumber: "number",
    }),
    ...mapGetters("organization", {
      organizationName: "fullNameOrg"
    }),
    ...mapGetters("user", {
      userEmail: "email",
    }),
    ...mapGetters("accountingPoints", {
      accountingPoints: "allPoints",
    }),
    ...mapGetters("appeals", {
      themeName: "themeName",
      themeId: "themeId",
      themeTypes: "themeTypes",
      themeTypesId: "themeTypesId",
    }),
    ...mapState({ accountingPoint: "accountingPoint" }),
    ...mapGetters({
      sortedPointsByObject: "accountingPoints/sortedPointsByObject",
    }),
  },
  data: () => ({
    requiredRule: [
      v => !!v || 'Заполните данное поле',
    ],
  }),
})
class AppealsAdd  extends Mixins(AppApiMixin) {
  appealThemesArr: {[x: string]: number} = {};
  appealThemeTypesArr: {[x: string]: number} = {};
  accountingPointsArr: {[x: string]: number} = {};
  accountingPointsObjectsArr: {[x: string]: number} = {};

  values: {[x: string]: any} = {};
  isFormValid = false;

  // флаги тем ПП890
  isReturnTheme = false;
  isChangeTheme = false;
  isCloseTheme = false;
  // качество
  isQualityTheme = false;

  file: Array<File> | [];
  submitSuccessText = "";
  submitErrorText = "";
  useSuccessAlert = false;
  useSubmitButtonLoading = false;

  // блокировка кнопки
  isSendDisabled = false;

  noAPointsForSelect = 'Точки учета отсутствуют'

  basedItems = ["За задолженность", "Заявление потребителя"];
  tarifItems = ["День/Ночь", "Однотарифный", "Ночь/Пик/Полупик"];
  levelItems = ["Полное", "Частичное"];

  // вариант ответа на обращение
  answerType = ["Через личный кабинет", "Посредством электронной почты", "Иной способ, предусмотренный договором энергоснабжения (почтовое отправление)"];

  // file_count = 0;
  min = null;
  max = null;

  qualityDateMin = null;
  qualityDateMax = null;
  qualityDateValue = null;

  mounted() {
    this.getAllAppealThemes(this.contractId);

    this.values['email'] = this.userEmail;

    // поля для ПП890
    let startDate = moment();
    let endOfMonth = moment().endOf('month');

    if (endOfMonth.diff(startDate, 'days') >= 10) {
      // от 10 дней до конца расчетного периода
      startDate = startDate.add(1, 'months').startOf('month');
    } else {
      // менее 10 дней, указываем через месяц
      startDate = startDate.add(2, 'months').startOf('month');
    }

    this.min = startDate.format('YYYY-MM-DD');
    this.max = startDate.add(3, 'months').format('YYYY-MM-DD')
    this.values['date'] = this.min;

    // качество
    this.values['orgName'] = this.organizationName;
    this.values['contractNo'] = this.contractNumber;
    this.qualityDateMin = moment().subtract(3, 'years').format('YYYY-MM-DD');
    this.qualityDateMax = moment().format('YYYY-MM-DD');
    this.values['qualityDate'] = this.qualityDateMax;
    this.qualityDateValue = moment().format('DD.MM.YYYY');
    this.values['qualityTime'] = null;

    // снимаем блокировку
    this.isSendDisabled = false;
  }

  /**
   * ДАННЫЕ
   */

  /**
   * Список тем обращений
   */
  public get appealThemeItems() {
    const themes = this.themeName ? this.themeName.map((name: AppealThemes) => name.название) : [];
    const appealThemesArr_ids = this.themeName ? this.themeName.map((name: AppealThemes) => name.$номерЗаписи) : [];

    themes.forEach((item, index) => {
      this.appealThemesArr[item] = appealThemesArr_ids[index];
    });
    return [...themes]
  }

  /**
   * Список вопросов из темы обращения
   */
  public get appealTypeItems() {
    const themeTypes = this.themeTypes ? this.themeTypes.map((name: AppealThemeTypes) => name.название) : [];
    const themeTypes_mas_ids = this.themeTypes ? this.themeTypes.map((name: AppealThemeTypes) => name.$номерЗаписи) : [];

    themeTypes.forEach((item:number, index:number) => {
      this.appealThemeTypesArr[item] = themeTypes_mas_ids[index];
    });

    return [...themeTypes];
  }

  /**
   * Список точек учета
   */
  public get accountingPointsForSelect() {
    const accountingPointsArr = this.accountingPoints ? this.accountingPoints.map((name: AccountingPoint) => name.названиету) : [];
    const accountingPointsArr_ids = this.accountingPoints ? this.accountingPoints.map((name: AccountingPoint) => name.лицевой) : [];
    const accountingPointsObjectsArr_ids = this.accountingPoints ? this.accountingPoints.map((name: AccountingPoint) => name.объект) : [];

    accountingPointsArr.forEach((item, index) => {
      this.accountingPointsArr[item] = accountingPointsArr_ids[index];
      this.accountingPointsObjectsArr[item] = accountingPointsObjectsArr_ids[index];
    });

    if (accountingPointsArr.length > 0) {
      return [...accountingPointsArr];
    } else {
      return [this.noAPointsForSelect];
    }
  }

  /**
   * Список приборов по точкам учета
   */
  public get accountingPointObjectsForSelect() {
    if (this.accountingPointsObjectsArr) {
      const objectId = this.accountingPointsObjectsArr[this.values['accountingPoint']];
      if (objectId) {
        const sortedPointsByObject = this.sortedPointsByObject ? this.sortedPointsByObject.filter(
          (point: any) => point.objectId == objectId) : [];
        let accountingPointsObjectsArr = [];
        sortedPointsByObject.forEach((item) => {
          if (item.pointList) {
            item.pointList.forEach((point) => {
              accountingPointsObjectsArr.push("Номер " + (point.номер || "") + " Тип ПУ " + (point.типсчетчика || "") + " Заводской номер " + (point.заводскойномер || ""));
            });
          }
        });
        return accountingPointsObjectsArr;
      }
    }
    return [];
  }

  /**
   * Доступные расширения для файлов
   */
  getAppealsAcceptedExtensions() { return appealsAcceptedExtensions() }
  getAppealsAcceptedExtensionsText() { return 'Доступны форматы: ' + appealsAcceptedExtensions() }

  /**
   * СОБЫТИЯ
   */

  /**
   * Изменение выбранной темы
   */
  onSelectTheme() {
    this.isReturnTheme = (this.values['appealTheme'] === "Возобновление подачи электрической энергии");
    this.isChangeTheme = (this.values['appealTheme'] === "Установление и изменение зон суток в соответствии с дифференциацией тарифов (тарифные зоны)");
    this.isCloseTheme = (this.values['appealTheme'] === "Полное и (или) частичное ограничение режима потребления электрической энергии");
    this.isQualityTheme = (this.values['appealTheme'] === "Нарушение качества электрической энергии, требований к обеспечению надежности снабжения");
    this.validateForm();
  }

  /**
   * Изменение выбранной точки учета
   */
  onSelectAccountingPoint() {
    let tu = "";
    let address = "";
    if (this.accountingPoints) {
      const selectedAccountingPoint = this.accountingPointsArr[this.values['accountingPoint']];
      this.accountingPoints.forEach((item: AccountingPoint) => {
        if (item.лицевой == selectedAccountingPoint) {
          tu = item.номер.toString();
          address = item.адрес;
        }
      });
    }
    this.values['tu'] = tu;
    this.values['address'] = address;
  }

  /**
   * Изменение поля файлов
   */
  onFileChanged(files: Array<File>) {
    this.file = files;
  }

  /**
   * Отправка обращения
   */
  async submitForm() {
    this.useSuccessAlert = false
    this.useSubmitButtonLoading = true
    const formData = new FormData
    for (let key in this.values) {
      switch (key) {
        case "appealTheme":
          if (this.values[key] != "" && this.appealThemesArr)
          formData.append(key, this.appealThemesArr[this.values[key]].toString());
          break;
        case "appealType":
          if (this.values[key] != "" && this.appealThemeTypesArr) {
            formData.append(key, this.appealThemeTypesArr[this.values[key]].toString());
          }
          break;
        case "accountingPoint":
          if (this.values[key] != "" && this.accountingPointsArr) {
            formData.append(key, (this.accountingPointsArr[this.values[key]] || "").toString());
          }
          break;
        case "file":
          if (this.file) {
            for (let file of this.file) {
              formData.append("file[]", file);
            }
          }
          break;
        default:
          if (this.showField(key)) {
            formData.append(key, this.values[key]);
          }
          break;
      }
    }

    formData.append('contractId', this.contractId);

    try {
      const data = await this.sendAppeal(formData)

      if(data && data.result && (data.appealId) != 0) {
        this.submitSuccessText = 'Обращение успешно отправлено';

        this.useSuccessAlert = true;

        // блокировка кнопки
        this.isSendDisabled = true;

        setTimeout(() => (this.$router.push({ name: "appealsByDogovor", params: { contractId: this.contractId } })), 2000);
      }

    } catch (e) {
      this.submitErrorText = e.data;
    }
    this.submitSuccessText = '';
    this.useSubmitButtonLoading = false
  }

  /**
   * ФИЛЬТРЫ
   */

  /**
   * Фильтр для отображения поля
   * @param fieldName
   */
  showField(fieldName) {
    switch (fieldName) {
      case "message": return true;
      case "file": return this.isQualityTheme;
    }
    return this.requiredField(fieldName);
  }

  /**
   * Фильтр для полей, обязательных к заполнению
   * @param fieldName
   */
  requiredField(fieldName) {
    switch (fieldName) {
      case "message": return false; // (!this.isReturnTheme && !this.isChangeTheme && !this.isCloseTheme);
      case "file": return false; // return (!this.isReturnTheme && !this.isChangeTheme && !this.isCloseTheme);
      case "accountingPoint": return this.isReturnTheme || this.isChangeTheme || this.isCloseTheme || this.isQualityTheme;
      case "pu":
      case "tu":
      case "address":
      case "date": return this.isReturnTheme || this.isChangeTheme || this.isCloseTheme;
      case "based": return this.isReturnTheme;
      case "reason": return this.isCloseTheme;
      case "tarif": return this.isChangeTheme;
      case "level": return this.isCloseTheme;
      case "orgName": return this.isQualityTheme;
      case "contractNo": return this.isQualityTheme;
      case "answerType": return this.isQualityTheme;
      case "qualityDate": return this.isQualityTheme;
      case "qualityTime": return this.isQualityTheme;
    }
    return true;
  }

  /**
   * Валидация в зависимости от типа заявки
   * @param fieldName
   */
  customRule(fieldName) {
    if (fieldName == "file") {
      return [];
    }
    if (this.requiredField(fieldName)) {
      if (fieldName == "email") {
        return [
          v => !!v || 'Заполните данное поле',
          v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Неправильный формат",
          // v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v) || "Неправильный формат",
        ]
      }
      if (fieldName == "phone") {
        return [
          v => !!v || 'Заполните данное поле',
          (v) => {
            const endRegExp = "([- ]?\\d{2}){2}$";
            const phonePatterns = [
              new RegExp("^(\\d{4}|\\(\\d{4}\\))[- ]?\\d{2}" + endRegExp),
              new RegExp("^(\\d{3}|\\(\\d{3}\\))[- ]?\\d{3}" + endRegExp)
            ];
            return phonePatterns.some(pattern => pattern.test(v)) || "Неправильный формат";
          }
        ]
      }
      return [
        v => !!v || 'Заполните данное поле',
      ];
    }
    return [];
  }

  validFields = true;
  validateForm() {
    if (this.isQualityTheme) {
      const HH = (this.values['qualityTime'] ? this.values['qualityTime']['HH'] : "").replace(/^\D+/g, "");
      const mm = (this.values['qualityTime'] ? this.values['qualityTime']['mm'] : "").replace(/^\D+/g, "");
      if (HH == "" || mm == "") {
        this.validFields = false;
        return;
      }
    }
    this.validFields = true;
  }
}

export default AppealsAdd

